import _ from 'lodash';
import Vue from 'vue';
import Employees from '@/views/constants/employees';
import EmployeesResource from '@/resources/constants/employees';
import { SubNavigationTab } from '@/shared/helpers/classes';
import TabHelper from '@/shared/helpers/tabs';

import App from '@/views/constants/app';

const state = {
  employeesActiveView: Employees.Views.Index,
  employeesTabs: [
    new SubNavigationTab({
      component: 'EmployeesIndex',
      text: 'Werknemers overzicht',
      props: null,
      navigateAction: Employees.Actions.Tabs.OPEN,
      isCloseable: false,
      closeAction: null,
      isSingleton: true,
      isActive: true
    })
  ],
  isEmployeeSwitchModalOpen: false
};

const getters = {
  employeesActiveView: state => state.employeesActiveView,
  employeesTabs: state => state.employeesTabs,
  isEmployeeSwitchModalOpen: state => state.isEmployeeSwitchModalOpen
};

const actions = {
  [Employees.Actions.Navigate.DO] ({ commit }, view) {
    commit(Employees.Mutations.ActiveView.SET, view);
  },

  [Employees.Actions.Details.OPEN] ({ commit }, employee) {
    let employeeTab = _.find(state.employeesTabs, tab => {
      if (tab.props != null && tab.props.employeeId != null) {
        if (tab.props.employeeId === employee.id) {
          return tab;
        }
      }
    });

    if (employeeTab == null) {
      employeeTab = new SubNavigationTab({
        component: 'EmployeeDetails',
        text: employee.getFullName(),
        props: { employeeId: employee.id },
        navigateAction: Employees.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: Employees.Actions.Tabs.CLOSE,
        isSingleton: false,
        isActive: false
      });
    }

    commit(Employees.Mutations.Tabs.ADD, employeeTab);
    commit(Employees.Mutations.Tabs.OPEN, employeeTab);
  },

  [Employees.Actions.New.OPEN] ({ commit }) {
    let newTab = _.find(state.employeesTabs, tab => tab.component === 'NewEmployee');

    if (newTab == null) {
      newTab = new SubNavigationTab({
        component: 'NewEmployee',
        text: 'Nieuwe werknemer toevoegen',
        props: null,
        navigateAction: Employees.Actions.Tabs.OPEN,
        isCloseable: true,
        closeAction: Employees.Actions.Tabs.CLOSE,
        isSingleton: true,
        isActive: false
      });
    }

    commit(Employees.Mutations.Tabs.ADD, newTab);
    commit(Employees.Mutations.Tabs.OPEN, newTab);
  },

  [Employees.Actions.Tabs.OPEN] ({ commit }, tab) {
    commit(Employees.Mutations.Tabs.OPEN, tab);
  },

  [Employees.Actions.Tabs.CLOSE] ({ commit }, tab) {
    commit(Employees.Mutations.Tabs.CLOSE, tab);
  },

  [EmployeesResource.Actions.Create.SUCCESS] ({ commit, getters }, data) {
    Vue.toasted.success('Nieuwe werknemer is succesvol toegevoegd', {
      icon: 'done'
    });
    commit(Employees.Mutations.Tabs.CLOSE,
      getters.employeesTabs.find(tab => tab.component === 'NewEmployee'));
    commit(Employees.Mutations.Tabs.OPEN,
      getters.employeesTabs.find(tab => tab.component === 'EmployeesIndex'));
  },

  [Employees.Actions.SwitchModal.OPEN] ({ commit }) {
    commit(Employees.Mutations.SwitchModal.OPEN);
  },
  [Employees.Actions.SwitchModal.CLOSE] ({ commit }) {
    commit(Employees.Mutations.SwitchModal.CLOSE);
  }
};

const mutations = {
  [Employees.Mutations.CLEAR] (state) {
    state.employeesActiveView = Employees.Views.Index;
    state.employeesTabs = [
      new SubNavigationTab({
        component: 'EmployeesIndex',
        text: 'Werknemers overzicht',
        props: null,
        navigateAction: Employees.Actions.Tabs.OPEN,
        isCloseable: false,
        closeAction: null,
        isSingleton: true,
        isActive: true
      })
    ];
  },

  [App.Mutations.CLEAR] (state) {
    state.employeesActiveView = Employees.Views.Index;
    state.employeesTabs = [
      new SubNavigationTab({
        component: 'EmployeesIndex',
        text: 'Werknemers overzicht',
        props: null,
        navigateAction: Employees.Actions.Tabs.OPEN,
        isCloseable: false,
        closeAction: null,
        isSingleton: true,
        isActive: true
      })
    ];
  },

  [Employees.Mutations.ActiveView.SET] (state, payload) {
    state.employeesActiveView = payload;
  },

  [Employees.Mutations.Tabs.ADD] (state, payload) {
    state.employeesTabs = TabHelper.addTab(payload, state.employeesTabs);
  },

  [Employees.Mutations.Tabs.OPEN] (state, payload) {
    state.employeesTabs = TabHelper.activateTab(payload, state.employeesTabs);
  },

  [Employees.Mutations.Tabs.CLOSE] (state, payload) {
    TabHelper.removeTab(payload, state.employeesTabs);
  },

  [EmployeesResource.Mutations.UPSERT] (state, payload) {
    state.employeesTabs.forEach(t => {
      if (t.props != null && t.props.employeeId === payload.id) {
        t.text = payload.getFullName();
      }
    });
  },

  [Employees.Mutations.SwitchModal.OPEN] (state) {
    state.isEmployeeSwitchModalOpen = true;
  },
  [Employees.Mutations.SwitchModal.CLOSE] (state) {
    state.isEmployeeSwitchModalOpen = false;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
